export default "__VITE_ASSET__c1424375__"